import { render, staticRenderFns } from "./CongressmanUnProcessing.vue?vue&type=template&id=62f850fc&scoped=true"
import script from "./CongressmanUnProcessing.vue?vue&type=script&lang=js"
export * from "./CongressmanUnProcessing.vue?vue&type=script&lang=js"
import style0 from "./CongressmanUnProcessing.vue?vue&type=style&index=0&id=62f850fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f850fc",
  null
  
)

export default component.exports